module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mediaType !== 'midi') ? _c('div', {
    staticClass: "ksm-player__controls-row",
    staticStyle: {
      "border-bottom": "0",
      "background-color": "#d9d9da"
    }
  }, [_c('div', {
    staticClass: "ksm-player-btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-player__row-middle",
    staticStyle: {
      "border": "0",
      "background-color": "#d9d9da",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "overflow": "hidden",
      "height": "100%",
      "padding": "0 15px"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "height": "500",
      "viewBox": "0 0 3000 500",
      "preserveAspectRatio": "xMinYMin meet"
    }
  }, _vm._l((_vm.svgData), function(d, i) {
    return _c('g', {
      key: i
    }, [_c('rect', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (d.tooltipOpt),
        expression: "d.tooltipOpt"
      }],
      class: d.class,
      attrs: {
        "x": d.x,
        "width": d.width,
        "height": "100%"
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-player-btn",
    staticStyle: {
      "background-color": "#d9d9da"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ksm-player__controls-row"
  }, [_c('g-play-btn', {
    style: (_vm.playBtnDisable ? 'opacity:0.2' : ''),
    attrs: {
      "isPlaying": _vm.isPlaying
    },
    on: {
      "click": function($event) {
        return _vm.play(1)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-player__row-middle"
  }, [_c('input', {
    staticClass: "ksm-player__seekbar",
    attrs: {
      "type": "range",
      "value": "0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ksm-player-btn ksm-player-btn ksm-player-mute",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": require("icons/loud-volume.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d9c816d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/texte/ursonate/PlayerControls.vue
// module id = 1978
// module chunks = 1